import { PanelItemGroup } from '../panel-item-group.class';
import { COMPONENT_PLACEMENT_FRONT_AND_TOP, COMPONENT_PLACEMENT_TOP_ONLY } from '../../../component-classes/constants';

export const hasCountertopAppliancesCfn = (panelItemGroup: PanelItemGroup): boolean => {
	// console.log('TODO: hasCountertopAppliances', panelItemGroup);

	const topItems = panelItemGroup.items.children.filter((i) => i.item.placement === COMPONENT_PLACEMENT_FRONT_AND_TOP || i.item.placement === COMPONENT_PLACEMENT_TOP_ONLY);
	return topItems.length > 0;
};
